(function($) {

	'use strict';

	var init = function() {
        buttonInit()
    };

    var buttonInit = function() {
        $('a.button--primary').wrapInner("<span class='text'></span>")
        $('a.button--white').wrapInner("<span class='text'></span>")
    }

	$(document).ready(function() {
		init(); 
	});

})(jQuery);
